export const tourPricesApiQueryKeys = {
  all: () => ['prices'] as const,
  byTour: (tourId: string) => ['tours', tourId, 'prices'] as const,
};
